export { default } from './Promotions'
